enum SagaMonitorActionType {
	SET_EFFECT = "SET_EFFECT",
	DELETE_EFFECT = "DELETE_EFFECT",
}

export default SagaMonitorActionType;

